var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13H8.25C6.85761 13 5.52226 13.5172 4.53769 14.4378C4.06253 14.8821 3.68786 15.4029 3.42735 15.9691C2.92073 17.0702 3.73628 18.2039 4.91926 18.468C6.12026 18.7362 7.84853 19 10 19C12.1515 19 13.8797 18.7362 15.0807 18.468C16.2637 18.2039 17.0793 17.0702 16.5727 15.9691C16.3121 15.4029 15.9375 14.8821 15.4623 14.4378C14.4777 13.5172 13.1424 13 11.75 13Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.18859C6 4.07771 6.42143 3.01232 7.17157 2.22681C7.92172 1.4413 8.93913 1 10 1C11.0609 1 12.0783 1.4413 12.8284 2.22681C13.5786 3.01232 14 4.07771 14 5.18859C14 7.51359 12.2092 10 10 10C7.79077 10 6 7.51359 6 5.18859Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.ed4f3ecece51caecfe6152d2368aa403.svg";
export { ForwardRef as ReactComponent };